export function saveToLocalStorage(key, value) {
    if (!key || !value) {
        console.error("Key and Value must be provided to save to LocalStorage");
        return;
    }
    try {
        localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
        console.error(e);
    }
}

export function loadFromLocalStorage(key) {
    if (!key) {
        console.error("Key must be provided to load from LocalStorage");
        return null;
    }
    try {
        return JSON.parse(localStorage.getItem(key));
    } catch (e) {
        console.error(e);
        return null;
    }
}
